// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_mp-0";
export var buttonContainer = "_mp-3";
export var cancelButton = "_mp-4";
export var headerSection = "_mp-6";
export var headerTitle = "_mp-9";
export var messageSideLeft = "_mp-1";
export var messageSideRight = "_mp-2";
export var orderNumberContainer = "_mp-7";
export var orderNumberLabel = "_mp-8";
export var submitButton = "_mp-5";